<template>
  <v-card elevation="0" width="1000px" class="perfil-card">
    <v-card-title class="px-0 py-0 banner-container">
      <img :src="imagemFundo" alt="Imagem de fundo" class="banner-img" />

      <div class="quadro-foto">
        <img
          v-if="!urlFotoPerfil"
          :src="fotoPadrao"
          class="foto"
          crossOrigin="anonymous"
        />
        <img
          v-else
          :src="urlFotoPerfil"
          class="foto"
          alt="Foto de Perfil"
          crossOrigin="anonymous"
        />
      </div>
    </v-card-title>
    <v-card-text class="dados">
      <h1 class="pessoa-nome">{{ dadosProcessados.pessoa_falecida.nome }}</h1>
      <div class="date">
        <div class="star">
          <img src="@/assets/images/icons/star.png" alt="Star icon" />
        </div>
        <h2 class="data-texto">{{ nascimentoFormatada }}</h2>
        <div class="cross">
          <img src="@/assets/images/icons/cross.png" alt="Cross icon" />
        </div>
        <h2 class="data-texto">{{ falecimentoFormatado }}</h2>
      </div>
      <div v-if="dadosProcessados.obituario" class="obituario">
        <p>{{ dadosProcessados.obituario }}</p>
      </div>
      <v-row class="mt-6" dense>
        <v-col cols="12" sm="6" class="px-3">
          <v-card class="ceremony-card velorio-card elevation-4 pa-4" hover>
            <div class="d-flex align-start">
              <div class="icon-container mr-4">
                <v-avatar size="30" class="velorio-avatar">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="white"
                  >
                    <title>candle</title>
                    <path
                      d="M12.5,2C10.84,2 9.5,5.34 9.5,7A3,3 0 0,0 12.5,10A3,3 0 0,0 15.5,7C15.5,5.34 14.16,2 12.5,2M12.5,6.5A1,1 0 0,1 13.5,7.5A1,1 0 0,1 12.5,8.5A1,1 0 0,1 11.5,7.5A1,1 0 0,1 12.5,6.5M10,11A1,1 0 0,0 9,12V20H7A1,1 0 0,1 6,19V18A1,1 0 0,0 5,17A1,1 0 0,0 4,18V19A3,3 0 0,0 7,22H19A1,1 0 0,0 20,21A1,1 0 0,0 19,20H16V12A1,1 0 0,0 15,11H10Z"
                    />
                  </svg>
                </v-avatar>
              </div>
              <div class="info flex-grow-1">
                <h3 class="ceremony-title velorio-title font-weight-bold mb-2">
                  Velório
                </h3>
                <div class="ceremony-location mb-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="17"
                    height="17"
                    fill="#343f53"
                    class="mr-1"
                  >
                    <title>map-marker</title>
                    <path
                      d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
                    />
                  </svg>
                  {{ dadosProcessados.local_velorio }}
                </div>
                <div class="ceremony-time mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="17"
                    height="17"
                    fill="#343f53"
                    class="mr-1"
                  >
                    <title>clock-outline</title>
                    <path
                      d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"
                    />
                  </svg>
                  {{ dataVelorioFormatada }}
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Sepultamento -->
        <v-col cols="12" sm="6" class="px-3">
          <v-card
            class="ceremony-card sepultamento-card elevation-4 pa-4"
            hover
          >
            <div class="d-flex align-start">
              <div class="icon-container mr-4">
                <v-avatar size="30" class="sepultamento-avatar">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="white"
                  >
                    <title>coffin</title>
                    <path
                      d="M8,22L5,8L8,2H16L19,8L16,22H8M11,6V8H9V10H11V15H13V10H15V8H13V6H11Z"
                    />
                  </svg>
                </v-avatar>
              </div>
              <div class="info flex-grow-1">
                <h3
                  class="ceremony-title sepultamento-title font-weight-bold mb-2"
                >
                  Sepultamento
                </h3>
                <div class="ceremony-location mb-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="17"
                    height="17"
                    fill="#343f53"
                    class="mr-1"
                  >
                    <title>map-marker</title>
                    <path
                      d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
                    />
                  </svg>
                  {{ dadosProcessados.local_sepultamento }}
                </div>
                <div class="ceremony-time mb-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="17"
                    height="17"
                    fill="#343f53"
                    class="mr-1"
                  >
                    <title>clock-outline</title>
                    <path
                      d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"
                    />
                  </svg>
                  {{ dataSepultamentoFormatada }}
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-divider
        class="my-6"
        v-if="dadosProcessados.mensagens.length > 0"
      ></v-divider>
      <v-row v-if="dadosProcessados.mensagens.length > 0">
        <v-col cols="12">
          <h2 class="title">Mensagens</h2>
        </v-col>

        <div class="messages-container">
          <div
            class="message-card"
            v-for="post in dadosProcessados.mensagens"
            :key="post.id"
          >
            <div class="message-header">
              <div class="message-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="#343f53"
                >
                  <title>account-circle</title>
                  <path
                    d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
                  />
                </svg>
              </div>
              <div class="message-info">
                <div class="message-author">
                  <span class="message-name">{{ post.nome }}</span>
                </div>
              </div>
            </div>
            <div class="message-content">
              {{ post.descricao }}
            </div>
            <div class="message-image" v-if="post?.imagem">
              <img :src="post?.imagem" alt="">
            </div>
            <div class="message-footer">{{ formatDate(post.data) }}</div>
          </div>
        </div>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <h2 class="title">Mensagens</h2>
        </v-col>

        <div class="messages-container">
          <p>
            Nenhuma mensagem encontrada.
          </p>
        </div>
      </v-row>

      <v-divider class="mt-6 mb-2"></v-divider>
      <div
        class="d-flex flex-column align-center justify-space-between footer-container"
      >
        <p class="footer-text">Gerado pelo Parque das Recordações</p>
        <img
          :src="require('@/assets/images/logos/grupoparque3.png')"
          alt="Logo"
          class="footer-logo mt-2"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { getFotoPerfilUrl } from "@/services/config";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");
const props = defineProps({
  dados: {
    type: Object,
    required: true,
  },
});

// Dados são gerenciados pelo computed dadosProcessados
const dadosProcessados = computed(() => {
  // Valores padrão para todos os campos
  const dadosPadrao = {
    id: 0,
    nome_arquivo_foto_perfil: "",
    foto_fundo: "",
    funeraria: "",
    data_velorio: "",
    local_velorio: "",
    codigo_jazigo: "",
    data_sepultamento: "",
    local_sepultamento: "",
    localizacao_sepultado: "",
    mensagens: [],
    obituario: "",
    pessoa_falecida: {
      nome: "",
      data_nascimento: "",
      data_falecimento: "",
    },
  };

  // Se props.dados existir, mescla com os valores padrão
  return props.dados ? { ...dadosPadrao, ...props.dados } : dadosPadrao;
});

const urlFotoPerfil = computed(() =>
  getFotoPerfilUrl(dadosProcessados.value.nome_arquivo_foto_perfil)
);

const fotoPadrao = computed(() => {
  return dadosProcessados.value.pessoa_falecida?.sexo?.toLowerCase() ===
    "Feminino"
    ? require("@/assets/feminino.png")
    : require("@/assets/masculino.png");
});

const formatarData = (dataHoraStr, formato = "extenso") => {
  if (!dataHoraStr) return "";

  const meses = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];

  // Separa data e hora
  const [dataStr, horaStr] = dataHoraStr.split(" ");

  if (!dataStr) return "";

  const [ano, mes, dia] = dataStr.split("-");
  if (!ano || !mes || !dia) return dataHoraStr;

  if (formato === "extenso") {
    // Pega só hora e minuto, ex: "11:00"
    const horaFormatada = horaStr ? horaStr.slice(0, 5) : "";

    // Monta string: "18 de junho de 2025 - 11:00h"
    return (
      `${parseInt(dia)} de ${meses[parseInt(mes) - 1]} de ${ano}` +
      (horaFormatada ? ` - ${horaFormatada}h` : "")
    );
  } else if (formato === "curto") {
    return (
      `${dia.padStart(2, "0")}/${mes.padStart(2, "0")}/${ano}` +
      (horaStr ? ` ${horaStr}` : "")
    );
  }

  return dataHoraStr;
};

const formatDate = (date) => {
      if (!date) return "Não definido";
      return dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY");
};

// Datas formatadas usando os dados processados
const dataVelorioFormatada = computed(() =>
  formatarData(dadosProcessados.value.data_velorio, "extenso")
);

const dataSepultamentoFormatada = computed(() =>
  formatarData(dadosProcessados.value.data_sepultamento, "extenso")
);

const nascimentoFormatada = computed(() =>
  formatarData(dadosProcessados.value.pessoa_falecida.data_nascimento, "curto")
);

const falecimentoFormatado = computed(() =>
  formatarData(dadosProcessados.value.pessoa_falecida.data_falecimento, "curto")
);

// Imagens com tratamento de erro
const imagemFundo = computed(() => {
  try {
    return dadosProcessados.value.foto_fundo
      ? require(`@/assets/pack-banners/${dadosProcessados.value.foto_fundo}.jpg`)
      : "";
  } catch (error) {
    console.error("Erro ao carregar imagem de fundo:", error);
    return "";
  }
});
</script>

<style scoped>
/* Estilos do banner */
.banner-container {
  position: relative;
  overflow: visible; /* permite que a foto sobreponha */
}

.banner-img {
  width: 100%;
  height: 20vh;
  display: block;
}

.quadro-foto {
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  overflow: hidden;
  border: 4px solid white;
  width: 150px;
  height: 150px;
  background: white;
  z-index: 10;
}

.foto {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Estilos dos dados principais */
.dados {
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.pessoa-nome {
  text-align: center;
  color: #343f53;
  font-weight: 700;
  font-size: 24px;
}

/* Estilos das datas */
.date {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.data-texto {
  text-align: center;
  color: #343f53;
  font-weight: 300;
  font-size: 20px;
}

.star,
.cross {
  display: flex;
  align-items: center;
  justify-content: center;
}

.star img,
.cross img {
  width: 20px;
}

.cross {
  margin-left: 1rem;
}

/* Estilos do obituário */
.obituario {
  margin-top: 1rem;
  text-align: center;
  color: #343f53;
  font-weight: 300;
  font-style: italic;
  opacity: 0.8;
  font-size: 20px;
  padding: 0 10rem;
}

/* Estilos dos cards de cerimônia */
.ceremony-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  transition: all 0.3s ease;
  height: 120px;
}

.velorio-card {
  border-left: 4px solid #343f53;
}

.sepultamento-card {
  border-left: 4px solid #4a5568;
}

.icon-container {
  flex-shrink: 0;
}

.velorio-avatar {
  background: linear-gradient(135deg, #343f53, #2a3441);
}

.sepultamento-avatar {
  background: linear-gradient(135deg, #4a5568, #343f53);
}

.info {
  width: 36vw;
  text-align: justify;
  color: #343f53;
  font-size: 1.2rem;
}

.ceremony-title {
  color: #343f53;
  font-size: 20px;
}

.velorio-title::after {
  content: "";
  display: block;
  width: 24%;
  height: 1px;
  background-color: #343f53;
}

.sepultamento-title::after {
  content: "";
  display: block;
  width: 44%;
  height: 1px;
  background-color: #343f53;
}

.ceremony-location {
  color: #34495e;
  font-size: 12px;
}

.ceremony-time {
  color: #7f8c8d;
  font-size: 12px;
}

/* Estilos do título da seção */
.title {
  color: #343f53;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  display: inline-block;
  position: relative;
  padding-bottom: 0.1rem;
}

.title::after {
  content: "";
  display: block;
  width: 120%;
  height: 3px;
  background-color: #343f53;
  position: absolute;
  bottom: 0;
  left: 0;
}

/* Estilos do logo e footer */
.container-logo {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.footer-container {
  width: 100%;
}

.footer-text {
  font-size: 12px;
  margin: 0;
  color: #343f53;
  font-weight: 300;
}

.footer-logo {
  width: 120px;
}

.footer-position {
  position: absolute;
  bottom: 0;
  left: 0;
}

.messages-container {
  max-width: 800px;
  min-width: 800px;
  padding: 1rem;
  min-height: 100vh;
  margin: 0 auto; /* This centers the container horizontally */
}

.message-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  max-height: 26rem;
}

.message-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.message-avatar {
  width: 32px;
  height: 32px;
  background: #dee2e6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.message-avatar i,
.message-icon {
  color: #343f53;
  font-size: 1rem;
}

.message-info {
  margin-left: 1rem;
  flex: 1;
}

.message-author {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}

.message-name {
  font-weight: 600;
  color: #212529;
  font-size: 0.95rem;
}
.message-content {
  color: #495057;
  line-height: 1.5;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.message-footer {
  font-size: 0.6rem;
  text-align: right;
}
.message-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.message-image img {
  width: 400px;
  height: 200px;
  object-fit: cover;
}

</style>
